import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type MenuWishlist = {
  menu_wishlist_id?: number; // 나만의 메뉴 idx
  menu_id?: number; // 메뉴 idx
  user_id?: number; // 유저 idx
  menu_option?: { [key: string]: Record<string, any> }; // 메뉴 옵션
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] MenuWishlist
   * --
   */
  getMenuWishlists: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_MENU_WISHLIST, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] MenuWishlist
   * --
   */
  getMenuWishlist: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_MENU_WISHLIST, {
        menu_wishlist_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] MenuWishlist
   * --
   */
  createMenuWishlist: async (body: MenuWishlist) => {
    try {
      const res = await $http.post(APIConstant.CREATE_MENU_WISHLIST, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] MenuWishlist
   * --
   */
  updateMenuWishlist: async (body: MenuWishlist) => {
    try {
      const { menu_wishlist_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_MENU_WISHLIST, {
        menu_wishlist_id: menu_wishlist_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] MenuWishlist
   * --
   */
  deleteMenuWishlist: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_MENU_WISHLIST, {
        menu_wishlist_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
